import { Typography } from "@repo/design-system";
import { VirusCheckboxList } from "./VirusCheckboxList";

interface IVirusFilterBarProps {
  viruses: string[] | null | undefined;
  selectedViruses: string[];
  onToggle: (virusName: string) => void;
  onClear: () => void;
}

export function VirusFilterBar({
  viruses,
  selectedViruses,
  onToggle,
  onClear,
}: IVirusFilterBarProps) {
  return (
    <aside className="flex h-full w-32 flex-shrink-0 flex-col gap-3 overflow-hidden rounded-xl border border-borderPrimary bg-backgroundPrimary p-3 md:w-40">
      <Typography
        variant="paragraph-xl-bold"
        className="flex-shrink-0 text-contentPrimary">
        Viruses
      </Typography>

      <div className="min-h-0 flex-1">
        <VirusCheckboxList
          viruses={viruses}
          selectedViruses={selectedViruses}
          onToggle={onToggle}
          onClear={onClear}
        />
      </div>
    </aside>
  );
}
